import { openNotification } from './notification.saga';

export const openNotificationPngDownload = openNotification({
  type: 'SHOW_NEUTRAL_NOTIFICATION',
  payload: 'Downloading PNG. This may take a few minutes.',
});
